export interface ActivityData {
  id: number;
  name: string;
  image: string;
  description?: string;
  term?: string;
}

export const activities: ActivityData[] = [
  {
    id: 1,
    name: "Art & Craft",
    image: "/images/activity/artcraft.webp",
    description: "Boosts creativity with drawing, painting, and craft projects.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 2,
    name: "Choir",
    image: "/images/activity/choir.webp",
    description: "Improves singing, harmony, and teamwork through group music.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 3,
    name: "Drama",
    image: "/images/activity/drama.webp",
    description: "Builds confidence through acting, scripts, and performances.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 4,
    name: "Netball & Football",
    image: "/images/activity/netballfootball.webp",
    description: "Promotes fitness, teamwork, and sportsmanship through games.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 5,
    name: "Pathfinder",
    image: "/images/activity/pathfinder.webp",
    description: "Develops leadership, outdoor skills, and community service values.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 6,
    name: "Spelling Bee",
    image: "/images/activity/spellingbee.webp",
    description: "Strengthens spelling, vocabulary, and confidence in competitions.",
    term: "Term 1 (Fall) - Aug to Dec",
  },
  {
    id: 7,
    name: "Chess",
    image: "/images/activity/chess.webp",
    description: "Builds strategy, focus, and problem-solving through chess play.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 8,
    name: "Choir",
    image: "/images/activity/choir.webp",
    description: "Builds confidence in singing and teamwork through performances.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 9,
    name: "Debate",
    image: "/images/activity/debate.webp",
    description: "Improves speaking, reasoning, and persuasion through debates.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 10,
    name: "Financial Literacy",
    image: "/images/activity/financialliteracy.webp",
    description: "Teaches saving, budgeting, and smart money decisions daily.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 11,
    name: "Journalism/Media",
    image: "/images/activity/journalism.webp",
    description: "Builds reporting, writing, and media production skills.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 107,
    name: "Cheerleading",
    image: "/images/activity/cheerleading.webp",
    description: "Boosts coordination, spirit, and confidence through routines.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 108,
    name: "Pathfinder",
    image: "/images/activity/pathfinder.webp",
    description: "Develops leadership, outdoor skills, and community service values.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 109,
    name: "Peer Club",
    image: "/images/activity/peerclub.webp",
    description: "Encourages friendship, mentorship, and positive student support.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 110,
    name: "Spelling",
    image: "/images/activity/spellingbee.webp",
    description: "Strengthens spelling, vocabulary, and confidence in competitions.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 111,
    name: "Track and field",
    image: "/images/activity/trackfield.webp",
    description: "Builds stamina, discipline, and sportsmanship through events.",
    term: "Term 2 (Spring) - Jan to March",
  },
  {
    id: 112,
    name: "4-H",
    image: "/images/activity/caymanh.webp",
    description: "Builds leadership, citizenship, and life skills through projects.",
    term: "Term 3 (Easter)",
  },
  {
    id: 113,
    name: "Art & Craft",
    image: "/images/activity/artcraft.webp",
    description: "Boosts creativity with drawing, painting, and craft projects.",
    term: "Term 3 (Easter)",
  },
  {
    id: 114,
    name: "Chess",
    image: "/images/activity/chess.webp",
    description: "Builds strategy, focus, and problem-solving through chess play.",
    term: "Term 3 (Easter)",
  },
  {
    id: 115,
    name: "Choir",
    image: "/images/activity/choir.webp",
    description: "Builds confidence in singing and teamwork through performances.",
    term: "Term 3 (Easter)",
  },
  {
    id: 116,
    name: "Pathfinder",
    image: "/images/activity/pathfinder.webp",
    description: "Develops leadership, outdoor skills, and community service values.",
    term: "Term 3 (Easter)",
  },
  {
    id: 117,
    name: "Vacational (AC Repairs)",
    image: "/images/activity/vacationalac.webp",
    description: "Teaches AC repair basics and maintenance for practical learning.",
    term: "Term 3 (Easter)",
  },
  {
    id: 118,
    name: "Builder’s (High)",
    image: "/images/activity/caymanh.webp",
    description: "Middle school leadership club focused on service and character building.",
    term: "Lunch Time",
  },
  {
    id: 119,
    name: "Key club (High)",
    image: "/images/activity/caymanh.webp",
    description: "High school service organization providing members with opportunities to provide service and build character.",
    term: "Lunch Time",
  },
  {
    id: 120,
    name: "Y2Y club (Youth Service)",
    image: "/images/activity/caymanh.webp",
    description: "Youth-to-Youth service club focusing on community support and student engagement.",
    term: "Lunch Time",
  },
  {
    id: 121,
    name: "Sports (Basketball-Primary)",
    image: "/images/activity/seasonalsports/basketballprimary.webp",
    description: "Primary school basketball development and team play.",
    term: "Seasonal Sports",
  },
  {
    id: 122,
    name: "Sports (Cricket-Primary)",
    image: "/images/activity/seasonalsports/cricketprimary.webp",
    description: "Primary school cricket training and seasonal matches.",
    term: "Seasonal Sports",
  },
  {
    id: 123,
    name: "Sports (Football-Primary)",
    image: "/images/activity/seasonalsports/footballprimary.webp",
    description: "Primary school football league and skill-building.",
    term: "Seasonal Sports",
  },
  {
    id: 124,
    name: "Sports (Netball-Primary)",
    image: "/images/activity/seasonalsports/netballprimary.webp",
    description: "Primary school netball competition and teamwork.",
    term: "Seasonal Sports",
  },
  {
    id: 125,
    name: "Sports (Volleyball-Primary)",
    image: "/images/activity/seasonalsports/volleyballprimary.webp",
    description: "Primary school volleyball introduction and games.",
    term: "Seasonal Sports",
  },
  {
    id: 126,
    name: "Sports (Basketball-High)",
    image: "/images/activity/seasonalsports/basketballhigh.webp",
    description: "High school competitive basketball and advanced training.",
    term: "Seasonal Sports",
  },
  {
    id: 127,
    name: "Sports (Cricket-High)",
    image: "/images/activity/seasonalsports/crickethigh.webp",
    description: "High school regional cricket tournaments and practice.",
    term: "Seasonal Sports",
  },
  {
    id: 128,
    name: "Sports (Football-High)",
    image: "/images/activity/seasonalsports/footballhigh.webp",
    description: "High school varsity football and inter-school matches.",
    term: "Seasonal Sports",
  },
  {
    id: 129,
    name: "Sports (Netball-High)",
    image: "/images/activity/seasonalsports/netballhigh.webp",
    description: "High school netball elite team and seasonal play.",
    term: "Seasonal Sports",
  },
  {
    id: 130,
    name: "Sports (Volleyball-High)",
    image: "/images/activity/seasonalsports/volleyballhigh.webp",
    description: "High school volleyball championship and skill refinement.",
    term: "Seasonal Sports",
  },
  {
    id: 131,
    name: "Adventurers’ Club",
    image: "/images/activity/caymanh.webp",
    description: "Club focused on character development through outdoor activities and service.",
    term: "Primary Club List (3:30-4:30)",
  },
  {
    id: 132,
    name: "Art - Monday",
    image: "/images/activity/artcraft.webp",
    description: "Creative arts session focusing on various techniques and projects.",
    term: "Primary Club List (3:30-4:30)",
  },
  {
    id: 133,
    name: "Drama- Monday",
    image: "/images/activity/drama.webp",
    description: "Performance arts and acting workshops held every Monday.",
    term: "Primary Club List (3:30-4:30)",
  },
  {
    id: 134,
    name: "Sign language - Thursday",
    image: "/images/activity/caymanh.webp",
    description: "Learning the basics of communication through American Sign Language.",
    term: "Primary Club List (3:30-4:30)",
  },
  {
    id: 135,
    name: "Spelling - Wednesday",
    image: "/images/activity/spellingbee.webp",
    description: "Weekly spelling practice and preparation for competitions.",
    term: "Primary Club List (3:30-4:30)",
  },
  {
    id: 136,
    name: "Sign language",
    image: "/images/activity/caymanh.webp",
    description: "After-school sign language classes for student enrichment.",
    term: "After School",
  },
];
 